import {pickBy as filter} from 'lodash';

export const initAddressBookStore = ({addresses, endpoints}) => {
  window.App.store.registerModule('addressBook', {
    namespaced: true,
    state: {
      addresses: addresses
    },
    mutations: {
      store(state, address) {
        state.addresses = {...state.addresses, [address.id]: address};
      },
      remove(state, {id}) {
        window.App.Vue.delete(state.addresses, id);
      },
    },
    getters: {
      billingAddresses: state => filter(state.addresses, address => address.type === 'billing'),
      shippingAddresses: state => filter(state.addresses, address => address.type === 'shipping'),
    },
    actions: {
      submit({commit}, address) {
        return window.App.Axios.post(endpoints.submit, address).then(response => {
          if (response.data.success) {
            commit('store', response.data.address);
          }

          return response;
        });
      },
      remove({commit}, address) {
        return window.App.Axios.post(endpoints.remove, address).then(response => {
          if (response.data.success) {
            commit('remove', address);
          }

          return response;
        });
      },
    }
  });
};

window.App.initAddressBookStore = initAddressBookStore;



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/AddressBookStoreModule.js